import React from 'react';
import {
  Button,
  ButtonTypes,
} from 'app/common/components/controls/button/button';
import Icon, { IconName } from 'app/common/components/controls/icon';
import { forTemplate } from 'app/common/lib/util/i18n';
import { useFeatureFlag } from '@trello/feature-flag-client';
import styles from './AutoEnableCalendar.less';

import { sendPluginUIEvent } from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
const format = forTemplate('auto_enable_calendar');
const CALENDAR_POWER_UP_ID = require('app/scripts/data/legacy-power-ups')
  .calendar;
const CalendarHero = require('resources/images/auto-enable-calendar/calendar-hero.jpg');

export enum PrimaryButtonText {
  OKTHANKS = 'ok-thanks',
  OPENCALENDAR = 'open-calendar',
}

export const PreloadHero = () => {
  new Image().src = CalendarHero;
};

interface AutoEnableCalendarProps {
  primaryButtonText: PrimaryButtonText;
  onDisableCalendarClick: () => void;
  onOpenDirectoryClick: () => void;
  onPrimaryButtonClick: () => void;
  countDueDates: () => number;
  idBoard: string;
  popoverFlag: string;
}

export const AutoEnableCalendar: React.FunctionComponent<AutoEnableCalendarProps> = ({
  primaryButtonText,
  onDisableCalendarClick,
  onOpenDirectoryClick,
  onPrimaryButtonClick,
  countDueDates,
  idBoard,
  popoverFlag,
}) => {
  const openDirectoryTextFlag = useFeatureFlag(
    'ecosystem.auto-enable-calendar-popover-open-directory-text',
    'learn-more-about-powerups',
  );
  return (
    <>
      <div className={styles.calendarHeroContainer}>
        <img
          alt="Calendar Hero"
          src={CalendarHero}
          className={styles.calendarHero}
        />
      </div>
      <div>
        <p>{format('auto-enable-calendar-message')}</p>
      </div>
      <div className={styles.buttonGroup}>
        <div>
          <Button
            buttonType={ButtonTypes.PRIMARY}
            onClick={() => {
              onPrimaryButtonClick();
              sendPluginUIEvent({
                idPlugin: CALENDAR_POWER_UP_ID,
                idBoard,
                event: {
                  action: 'clicked',
                  actionSubject: 'button',
                  actionSubjectId: 'autoEnableCalendarPrimaryButton',
                  source: 'autoEnableCalendarInlineDialog',
                  attributes: {
                    dueDateCount: countDueDates(),
                    popoverFlag,
                    primaryButtonText,
                  },
                },
              });
            }}
          >
            {format(primaryButtonText)}
          </Button>
        </div>
        <div>
          <a
            className={styles.quiet}
            role="button"
            onClick={() => {
              onDisableCalendarClick();
              sendPluginUIEvent({
                idPlugin: CALENDAR_POWER_UP_ID,
                idBoard,
                event: {
                  action: 'clicked',
                  actionSubject: 'button',
                  actionSubjectId: 'autoEnableCalendarDisableButton',
                  source: 'autoEnableCalendarInlineDialog',
                  attributes: {
                    dueDateCount: countDueDates(),
                    popoverFlag,
                  },
                },
              });
            }}
          >
            {format('disable-calendar')}
          </a>
        </div>
        <hr />
        <div>
          <a
            className={styles.quiet}
            role="button"
            onClick={() => {
              onOpenDirectoryClick();
              sendPluginUIEvent({
                idPlugin: CALENDAR_POWER_UP_ID,
                idBoard,
                event: {
                  action: 'clicked',
                  actionSubject: 'button',
                  actionSubjectId: 'autoEnableCalendarOpenDirectoryButton',
                  source: 'autoEnableCalendarInlineDialog',
                  attributes: {
                    dueDateCount: countDueDates(),
                    openDirectoryTextFlag: openDirectoryTextFlag,
                    popoverFlag,
                  },
                },
              });
            }}
          >
            {format(openDirectoryTextFlag)}
            <Icon name={IconName.PowerUp} className={styles.powerUpIcon} />
          </a>
        </div>
      </div>
    </>
  );
};
